export default {
    change_password_title: "Cambiar la contraseña",
    change_password_old_password: "Contraseña anterior",
    change_password_new_password: "Contraseña nueva",
    change_password_changed: "Contraseña cambiada",
    change_password_incorrect: "Nombre de usuario o contraseña incorrectos",
    change_password_limit_exceeded: "Límite de intentos excedido, por favor inténtelo después de algún tiempo"
};